<div class="map-frame" #frame>
  <google-map
    *ngIf="apiLoaded$ | async"
    [options]="options"
    height="100%"
    width="100%"
    (mapInitialized)="onMapReady($event)"
    (idle)="onIdle()"
    (mapClick)="onMapClick($event)"
    (mapDragstart)="closeSpaceMenu(); clearFocus()"
    (zoomChanged)="closeSpaceMenu()"
  ></google-map>

  <div
    class="space-menu"
    *ngIf="spaceMenu as menu"
    [class.below]="menu.below"
    [style.left.px]="menu.x"
    [style.top.px]="menu.y"
    role="dialog"
    [attr.aria-label]="menu.space.title"
    (keydown.escape)="closeSpaceMenu()"
  >
    <div class="space-menu__head">
      <div>
        <div class="space-menu__title">{{ menu.space.title }}</div>
        <div class="space-menu__meta">
          <span *ngIf="spaceDates(menu.space)">{{ spaceDates(menu.space) }} · </span>
          {{ menu.space.memberIds.length }} member{{ menu.space.memberIds.length === 1 ? '' : 's' }}
        </div>
      </div>
      <button mat-icon-button class="space-menu__close" (click)="closeSpaceMenu()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <button
      *ngIf="!isSelected(menu.space)"
      type="button"
      class="space-menu__action"
      (click)="filterBySpace(menu.space)"
    >
      <mat-icon aria-hidden="true">filter_alt</mat-icon>
      <span>Show only its members</span>
    </button>
    <button
      *ngIf="isSelected(menu.space)"
      type="button"
      class="space-menu__action"
      (click)="clearSpace()"
    >
      <mat-icon aria-hidden="true">filter_alt_off</mat-icon>
      <span>Back to all members</span>
    </button>
    <button type="button" class="space-menu__action" (click)="openSpacePage(menu.space)">
      <mat-icon aria-hidden="true">open_in_new</mat-icon>
      <span>Open space page</span>
    </button>
  </div>

  <div class="chat-tip" #chatTip role="tooltip" aria-live="polite"></div>

  <div class="search-chip" *ngIf="clickedLocation" role="status">
    <mat-icon aria-hidden="true">my_location</mat-icon>
    <span>Hover a member for their distance from here</span>
    <button type="button" class="search-chip__clear" (click)="clearSearch()">
      Clear
    </button>
  </div>
</div>
